<div class="account-thumbnail">
    {{ accountName | slice:0:2 | uppercase }}
</div>